<template>
    <div>
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
			<div class="cw-content-nosidenav">
				<!-- ***** start custom content ***** -->
				<h1>Registration</h1>

                
                <div v-if="accountType === 'self'">  
                    <h2>Thank you</h2>          
                    <p>Once you’ve created your ENERGY STAR Portfolio Manager® account and have added your buildings, return to the registration page to complete your Building Energy Disclosure Project registration.</p>
                    <ul>
                        <li>Instructions for setting up your account can be found in <a href="https://www.hydro.mb.ca/your_business/benchmarking/energy_star_portfolio_manager/pdf/portfolio_manager_user_guide.pdf" target="_blank">Manitoba Hydro’s setup guide</a>.</li>
                        <li>The Province of Manitoba also provides a <a href="https://www.gov.mb.ca/finance/greenbuilding/pubs/portfolio_manager_in_manitoba.pdf" target="_blank">detailed guide on how to use ENERGY STAR Portfolio Manager®</a>.</li>
                    </ul>
                    <p>If you have any questions, please <a href="/sustainability/building-energy-disclosure.stm#contact" target="_blank">contact us</a>.</p>
                </div>
                <div v-else>
                    <h2>Thank you &ndash; registration complete.</h2>
                    <p>Thanks for registering for the Building Energy Disclosure Project. We will contact you soon to confirm registration and to let you know if we have any questions.</p>
                    <p>For more information, visit the <a href="/sustainability/building-energy-disclosure.stm">project webpage</a> or view the <a href="/sustainability/documents/bedp/BEDP-project-guide.pdf">project guide</a>.</p>
                    <p>If you have any questions, please <a href="/sustainability/building-energy-disclosure.stm#contact" target="_blank">contact us</a>.</p>
                </div>
            </div>
			</main>
		</div>
    
    <!-- add after this -->
    </div>
</template>
<script>
    export default {
        name: 'thankyou',
        data: function () {
            return {
                accountType: ""
            }
        },
        mounted() {
            this.accountType = this.$store.getters.ACCOUNTTYPE;
        }
    }
</script>